// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".back[data-v-d93cf2c0]{-webkit-backdrop-filter:blur(5px);backdrop-filter:blur(5px);background-color:var(--dialog-mask);cursor:pointer;height:100dvh;left:0;position:fixed;top:0;width:100vw;z-index:11}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
